var React = require('react');

function NCentral (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group 1687"},[React.createElement("path",{"id":"Vector","d":"M33.5545 23.7175L21.9929 12.2756H45.1162V23.7175H33.5545Z","fill":"white","fillOpacity":"0.3","key":0}),React.createElement("path",{"id":"Vector_2","d":"M21.9682 12.2756V12.251L10.4563 0.83374H0.883789V33.1663H12.4454V21.7244L24.007 33.1663H33.5547V23.7175L21.9931 12.2756H21.9682Z","fill":"#E0E7F6","key":1}),React.createElement("path",{"id":"Vector_3","d":"M33.53 12.2756V0.83374H21.9683V12.251L21.9931 12.2756H33.53Z","fill":"#E0E7F6","key":2})]));
}

NCentral.defaultProps = {"width":"46","height":"34","viewBox":"0 0 46 34","fill":"none"};

module.exports = NCentral;

NCentral.default = NCentral;
